import {
  REEBELO_STORE_TO_LOCALE,
  type ReebeloB2bStoreT,
  type ReebeloStoreT,
} from '@lambda/reebelo';

/**
 * `<html lang>` for a store: its regional locale (`en-AU`, `de-DE`, …), the
 * same one its hreflang alternate advertises.
 *
 * Next's i18n locales stay bare languages (`en`, `fr`) because they also pick
 * the translation files and the `/fr` path prefix, so the region comes from
 * the store instead. When the page is in another of the store's languages —
 * French on the Canadian store — that language is kept with the store's
 * region (`fr-CA`).
 */
export const getHtmlLang = (
  store: ReebeloStoreT | ReebeloB2bStoreT,
  routerLocale?: string,
): string | undefined => {
  const storeLocale = REEBELO_STORE_TO_LOCALE[store];

  if (!storeLocale) {
    return routerLocale;
  }

  const [storeLanguage, region] = storeLocale.split('-');
  const pageLanguage = routerLocale?.split('-')[0];

  if (!pageLanguage || pageLanguage === storeLanguage || !region) {
    return storeLocale;
  }

  return `${pageLanguage}-${region}`;
};
